// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"497":"3e08398f","719":"c0eaeb9a","882":"89fc7207","980":"17e17192"}[chunkId] + ".chunk.js";
};